class DynamicPricing {
    constructor() {
      this.values = new Object();
      this.inputs = new Object();
      this.hidden_inputs = new Object();
      this.ranges = new Object();
      this.ranges.width = $("#width_range");
      this.ranges.height = $("#height_range");
      this.ranges.length = $("#length_range");
      this.inputs.width = $("#width_input");
      this.inputs.height = $("#height_input");
      this.inputs.length = $("#length_input");
      this.hidden_inputs.width = $("#dp_width");
      this.hidden_inputs.height = $("#dp_height");
      this.hidden_inputs.length = $("#dp_length");
      this.inputs.qty = $(".quantity-selector__input").first();
  
      $("[data-dp-form]").validate({
        debug: true,
        errorClass: "form-field-error",
      });
  
      //this.update(config, variant_id);
  
      this.inputs.width.keydown(
        function (event) {
          this.checkInput(event);
        }.bind(this)
      );
  
      this.inputs.height.keydown(
        function (event) {
          this.checkInput(event);
        }.bind(this)
      );
  
      this.inputs.length.keydown(
        function (event) {
          this.checkInput(event);
        }.bind(this)
      );
  
      jQuery(".dp_input").keyup(
        function (event) {
          this.recalculatePrice();
        }.bind(this)
      );
  
      $("#product-quantity-input").change(
        function (event) {
          this.recalculatePrice();
        }.bind(this)
      );
  
      $("[data-product-add-to-cart-button]").click(
        function (event) {
          let valid = this.inputs.width.valid();
          if (
            !this.inputs.height.valid() ||
            !this.inputs.width.valid() ||
            !this.inputs.length.valid()
          ) {
            event.preventDefault();
            return;
          }
  
          if (this.type) {
            var button = $("[data-product-add-to-cart-button]");
            button.prop("disabled", true);
            button.attr("aria-busy", "true");
            this.addCustomProduct();
            event.preventDefault();
          }
        }.bind(this)
      );
    }
  
    update(config, variant_id) {
      this.inputs.qty.val(1);
      this.variant_id = variant_id;
      this.type = null;
      this.config = config;
      this.minimal_price = config.price;
      this.minimal_compare_at_price = config.compare_at_price;
      if (config.data) {
        this.type = config.data.pricing_type;
        this.width_range = config.data.width_range;
        this.height_range = config.data.height_range;
        this.length_range = config.data.length_range;
  
        if (this.type == "length") {
          this.width = config.data.fixed_width;
          this.ranges.length.html(this.length_range);
  
          this.min_length = parseInt(this.length_range.split("-")[0]);
          this.max_length = parseInt(this.length_range.split("-")[1]);
          this.min_area = this.width * this.min_length; //minimal area in cm2
  
          this.inputs.length.rules("add", {
            required: true,
            range: [this.min_length, this.max_length],
          });
        } else {
          this.ranges.width.html(this.width_range);
          this.ranges.height.html(this.height_range);
  
          this.min_width = parseInt(this.width_range.split("-")[0]);
          this.min_height = parseInt(this.height_range.split("-")[0]);
          this.max_width = parseInt(this.width_range.split("-")[1]);
          this.max_height = parseInt(this.height_range.split("-")[1]);
  
          this.min_area = this.min_width * this.min_height; //minimal area in cm2
  
          this.inputs.width.rules("add", {
            required: true,
            range: [this.min_width, this.max_width],
          });
          this.inputs.height.rules("add", {
            required: true,
            range: [this.min_height, this.max_height],
          });
        }
  
        this.updateUnitPrice();
      }
  
      this.recalculatePrice();
  
      this.updateWidthVisibility();
    }
  
    addCustomProduct() {
      $("#dp_height").val(this.getHeight());
      $("#dp_width").val(this.getWidth());
      $("#dp_length").val(this.getLength());
  
      jQuery.ajax({
        type: "GET",
        url: "/apps/proxy",
        data: { id: this.variant_id, price: this.price / 100 },
        dataType: "json",
        success: function (data) {
          let new_prod_id = data["id"];
          let new_variant_id = data["variants"][0]["id"];
  
          if (new_variant_id) {
            var option = new Option(new_prod_id, new_variant_id);
            $(option).html(new_prod_id);
            $("[name=id]").append(option);
            $("[name=id]").val(new_variant_id);
  
            var form = $(".product-form__buy-buttons form").first()[0];
            form.requestSubmit();
          }
        },
      });
    }
  
    updateWidthVisibility() {
      jQuery(".custom-input-section").hide();
      jQuery(".c-custom-sizes__wrapper").hide();
      jQuery(".c-custom-sizes").removeClass("c-custom-sizes__wrapper");
      this.inputs.width.prop("disabled", true);
      this.inputs.height.prop("disabled", true);
      this.inputs.length.prop("disabled", true);
      this.inputs.width.val("");
      this.inputs.height.val("");
      this.inputs.length.val("");
  
      this.hidden_inputs.width.prop("disabled", true);
      this.hidden_inputs.height.prop("disabled", true);
      this.hidden_inputs.length.prop("disabled", true);
      this.hidden_inputs.width.val("");
      this.hidden_inputs.height.val("");
      this.hidden_inputs.length.val("");
  
      const $label = jQuery(
        ".product-form__option-selector.breite_auswählen .product-form__option-name"
      );
  
      if (
        jQuery(".c-custom-sizes__wrapper").length === 0 &&
        jQuery(
          ".product-form__variants .block-swatch:not(.is-disabled) [value=-]"
        ).length
      ) {
        jQuery(
          ".product-form__option-selector.breite_auswählen, .c-custom-sizes "
        ).wrapAll(
          "<div class='c-custom-sizes__wrapper' style='display: none;'></div>"
        );
        $label.text("1. " + $label.text());
      }
      if (
        jQuery(".c-custom-sizes__wrapper").length === 0 &&
        this.type == "length"
      ) {
        jQuery(
          ".product-form__option-selector.breite_auswählen, .c-custom-sizes "
        ).wrapAll(
          "<div class='c-custom-sizes__wrapper' style='display: none;'></div>"
        );
        // const $label = jQuery(".product-form__option-selector.breite_auswählen .product-form__option-name");
        $label.text("1. " + $label.text());
      } else if (this.type == "area") {
        jQuery(".c-custom-sizes").addClass("c-custom-sizes__wrapper");
      }
  
      if (this.type == "length") {
        jQuery(".c-custom-sizes__wrapper").show();
        jQuery(".length-input-section").show();
        // if (jQuery(window).width() < 768) {
        //     jQuery('html, body').animate({
        //         scrollTop: jQuery('.custom-size--wrapper').offset().top
        //     }, 1000);
        // }
        this.inputs.width.prop("disabled", true);
        this.inputs.height.prop("disabled", true);
        this.inputs.length.prop("disabled", false);
        this.inputs.length.val("");
  
        this.hidden_inputs.width.prop("disabled", true);
        this.hidden_inputs.height.prop("disabled", true);
        this.hidden_inputs.length.prop("disabled", false);
        this.hidden_inputs.length.val("");
  
        jQuery('.shopify-payment-button').hide();
        
      } else if (this.type == "area") {
        jQuery(".c-custom-sizes__wrapper").show();
        jQuery(".area-input-section").show();
        // if (jQuery(window).width() < 768) {
        //     jQuery('html, body').animate({
        //         scrollTop: jQuery('.custom-size--wrapper').offset().top
        //     }, 1000);
        // }
        this.inputs.width.prop("disabled", false);
        this.inputs.height.prop("disabled", false);
        this.inputs.length.prop("disabled", true);
  
        this.hidden_inputs.width.prop("disabled", false);
        this.hidden_inputs.height.prop("disabled", false);
        this.hidden_inputs.length.prop("disabled", true);
  
        // hide button with shopify-payment-button class
        jQuery('.shopify-payment-button').hide();
        
      }
  
      var dashOption = jQuery(
        "[data-product-options-container] .form-options [value=-]"
      );
  
      if (dashOption) {
        dashOption.parent().hide();
        let options_count = dashOption
          .parents(".option-values")
          .find("input:enabled").length;
        if (
          options_count == 1 &&
          dashOption.parents(".option-values").find("input:enabled").val() == "-"
        ) {
          dashOption.parents(".form-options, .custom-size--wrapper").hide();
        } else {
          dashOption.parents(".form-options, .custom-size--wrapper").show();
        }
      }
    }
  
    updateUnitPrice() {
      this.price_per_sqm = 0;
      if (this.type == "area") {
        var area = 100 * 100; // area in cm2
        if (this.min_area != 0)
          this.price_per_sqm = (area * this.minimal_price) / this.min_area;
      } else {
        var area = 100 * 100; // area in cm2
        if (this.min_area != 0)
          this.price_per_sqm = (area * this.minimal_price) / this.min_area;
      }
  
      if (this.price_per_sqm > 0)
        $(".price_per_sqm").html(
          this.formatMoney(this.price_per_sqm, "Quadratmeter: {{amount}} €")
        );
  
      if (["b2b", "b2binst"].includes(jQuery.cookie("customer_type"))) {
        if (this.price_per_sqm > 0)
          $(".price_per_sqm").html(
            this.formatMoney(
              this.price_per_sqm / 1.19,
              "Quadratmeter: {{amount}} €"
            )
          );
      } else {
        if (this.price_per_sqm > 0)
          $(".price_per_sqm").html(
            this.formatMoney(this.price_per_sqm, "Quadratmeter: {{amount}} €")
          );
      }
    }
  
    getWidth() {
      let value = parseInt(this.inputs.width.val());
      if (isNaN(value)) return 0;
      return value;
    }
  
    getHeight() {
      let value = parseInt(this.inputs.height.val());
      if (isNaN(value)) return 0;
      return value;
    }
  
    getLength() {
      let value = parseInt(this.inputs.length.val());
      if (isNaN(value)) return 0;
      return value;
    }
  
    setWidth(value) {
      this.inputs.height.val(value);
    }
  
    setHeight(value) {
      this.inputs.height.val(value);
    }
  
    setLenght(value) {
      this.inputs.length.val(value);
    }
  
    validate(el) {}
  
    checkInput(event) {
      let allowedKeyCode = [
        0,
        8,
        9, //delete,tab
        37,
        38,
        39,
        40, //arrows
        46, //numpad delete
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57, //numbers
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
      ]; // numpad numbers
      let code = window.event ? event.keyCode : event.which;
  
      if (Array.prototype.indexOf.call(allowedKeyCode, code) < 0) {
        event.preventDefault();
        return;
      }
    }
  
    recalculatePrice() {
      switch (this.type) {
        case "area":
          this.values.width = this.getWidth();
          this.values.height = this.getHeight();
  
          if (this.values.width < this.min_width)
            this.values.width = this.min_width;
          if (this.values.width > this.max_width)
            this.values.width = this.max_width;
          if (this.values.height < this.min_height)
            this.values.height = this.min_height;
          if (this.values.height > this.max_height)
            this.values.height = this.max_height;
  
          this.area = this.values.width * this.values.height;
          this.price = (this.area * this.minimal_price) / this.min_area;
          this.compare_at_price =
            (this.area * this.minimal_compare_at_price) / this.min_area;
          break;
        case "length":
          this.values.length = this.getLength();
  
          if (this.values.length < this.min_length)
            this.values.length = this.min_length;
          if (this.values.length > this.max_length)
            this.values.length = this.max_length;
  
          this.min_area = this.min_length * this.width;
          this.area = this.values.length * this.width;
          this.price = (this.area * this.minimal_price) / this.min_area;
          this.compare_at_price =
            (this.area * this.minimal_compare_at_price) / this.min_area;
          break;
        default:
          this.price = this.minimal_price;
          this.compare_at_price = this.minimal_compare_at_price;
      }
      this.price = Math.round(this.price);
  
      let qty = this.inputs.qty.val();
  
      //$('[data-price] .money').html(Shopify.formatMoney(this.price,'{{amount_with_comma_separator}} €'));
  
      if (["b2b", "b2binst"].includes(jQuery.cookie("customer_type"))) {
        $(".price--large").html(
          this.formatMoney(this.price / 1.19, "{{amount_with_comma_separator}} €")
        );
        if (this.compare_at_price > 0) {
          $(".product-meta__price-row .price--compare").html(
            this.formatMoney(
              this.compare_at_price / 1.19,
              "{{amount_with_comma_separator}} €"
            )
          );
          $(".product-meta__price-row .price--large").addClass(
            "price--highlight"
          );
        } else {
          $(".product-meta__price-row .price--compare").html("");
          $(".product-meta__price-row .price--large").removeClass(
            "price--highlight"
          );
        }
      } else {
        $(".price--large").html(
          this.formatMoney(this.price, "{{amount_with_comma_separator}} €")
        );
  
        if (this.compare_at_price > 0) {
          $(".product-meta__price-row .price--compare").html(
            this.formatMoney(
              this.compare_at_price,
              "{{amount_with_comma_separator}} €"
            )
          );
  
          $(".product-meta__price-row .price--large").addClass(
            "price--highlight"
          );
        } else {
          $(".product-meta__price-row .price--compare").html("");
          $(".product-meta__price-row .price--large").removeClass(
            "price--highlight"
          );
        }
      }
  
      // if(qty > 1) {
      //     $('.product--price-part').show();
      //     $('.product--price-part').html(qty+' x '+this.formatMoney(this.price,'{{amount_with_comma_separator}} €')+' = <span>'+this.formatMoney(qty*this.price,'{{amount_with_comma_separator}} €'+'</span>'));
      // } else {
      //     $('.product--price-part').hide();
      // }
    }
  
    formatMoney(cents, format = "") {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || window.themeVariables.settings.moneyFormat;
      function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100).toFixed(precision);
        let parts = number.split("."),
          dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      let value = "";
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_no_decimals_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 0, "'");
          break;
      }
      if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
      } else {
        return formatString.replace(placeholderRegex, value);
      }
    }
  }
  
  window.addEventListener("load", (event) => {
    let dp = new DynamicPricing();
  
    var id = jQuery(".product-form__buy-buttons [name=id]").val();
    let config = JSON.parse(
      document.querySelector("[data-dynamic-pricing]")?.innerHTML || null
    );
    var selected_variant = config && config[id];
    if (selected_variant) {
      dp.update(selected_variant, id);
    }
  
    document.addEventListener("variant:changed", function (event) {
      let variant = event.detail.variant; // Gives you access to the whole variant details
      let form = event.target;
      let config = JSON.parse(
        document.querySelector("[data-dynamic-pricing]")?.innerHTML || null
      );
      var selected_variant = config && config[variant.id];
      if (selected_variant) {
        dp.update(selected_variant, variant.id);
      }
      //update title of the product for selected variant
      const title = variant.name;
      $(".product-meta .product-meta__title").html(title);
    });
  
  
    // Function to create a closure around the event listener
    function createVariantChangedListener(dp, config) {
      return function (event) {
        let variant = event.detail.variant; // Gives you access to the whole variant details
        let selected_variant = config && config[variant.id];
        if (selected_variant) {
          dp.update(selected_variant, variant.id);
        }
        // Update title of the product for selected variant
        const title = variant.name;
        jQuery(".product-meta .product-meta__title").html(title);
      };
    }
  
    // Function to execute when the drawer opens
    const onDrawerOpen = (drawer) => {
      console.log('drawer open')
      let dp = new DynamicPricing();
      let id = jQuery(".product-form__buy-buttons [name=id]").val();
      let configText =
        document.querySelector("[data-dynamic-pricing]")?.innerHTML || "{}";
      let config = JSON.parse(configText);
      let selected_variant = config[id];
      if (selected_variant) {
        dp.update(selected_variant, id);
      }
  
      // Create the listener function
      const variantChangedListener = createVariantChangedListener(dp, config);
  
      // Add the event listener and store a reference to it on the drawer element
      document.addEventListener("variant:changed", variantChangedListener);
      drawer.variantChangedListener = variantChangedListener;
    };
  
    // Function to execute when the drawer closes
    const onDrawerClose = (drawer) => {
      // Check if the drawer has a stored reference to the listener
      if (drawer.variantChangedListener) {
        // Remove the event listener using the stored reference
        document.removeEventListener(
          "variant:changed",
          drawer.variantChangedListener
        );
        drawer.variantChangedListener = null;
      }
    };
  
    // MutationObserver callback function
    const observerCallback = function (mutationsList, observer) {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "open") {
          console.log(mutation)
          const drawer = mutation.target;
          if (drawer.hasAttribute("open")) {
            onDrawerOpen(drawer);
          } else {
            onDrawerClose(drawer);
          }
        }
      });
    };
  
    // Create a new observer instance with the callback function
    const observer = new MutationObserver(observerCallback);
  
    // Options for the observer (we're only interested in attributes)
    const observerOptions = {
      childList: true,
      subtree: true,
      attributes: true, // Watch for attribute changes
      attributeFilter: ["open"], // Specifically for the 'open' attribute
    };
    
  
  
    // Start observing each 'quick-buy-drawer' for mutations with the specified options
    const productsContainer = document.querySelector(".product-list__inner--list");
    observer.observe(productsContainer, observerOptions);
    // allDrawers.forEach((drawer) => {
    //   observer.observe(drawer, observerOptions);
    // });
  });
  
  /* 
  class DynamicPricing {
      constructor() {
  
          this.values = new Object();
          this.inputs = new Object();
          this.hidden_inputs = new Object();
          this.ranges = new Object();
          this.ranges.width = $('#width_range');
          this.ranges.height = $('#height_range');
          this.ranges.length = $('#length_range');
          this.inputs.width = $('#width_input');
          this.inputs.height = $('#height_input');
          this.inputs.length = $('#length_input');
          this.hidden_inputs.width = $('#dp_width');
          this.hidden_inputs.height = $('#dp_height');
          this.hidden_inputs.length = $('#dp_length');
          this.inputs.qty = $('.quantity-selector__input').first();
  
          $("[data-dp-form]").validate({
              debug: true,
              errorClass: "form-field-error",
          });
  
          //this.update(config, variant_id);
  
          this.inputs.width.keydown(function(event) {
              this.checkInput(event)
          }.bind(this));
  
          this.inputs.height.keydown(function(event) {
              this.checkInput(event)
          }.bind(this));
  
          this.inputs.length.keydown(function(event) {
              this.checkInput(event)
          }.bind(this));
  
          jQuery('.dp_input').keyup(function(event) {
              this.recalculatePrice();
          }.bind(this));
  
          $('#product-quantity-input').change(function(event) {
              this.recalculatePrice();
          }.bind(this));
  
          $('[data-product-add-to-cart-button]').click(function(event){
              let valid = this.inputs.width.valid();
              if(!this.inputs.height.valid() || !this.inputs.width.valid() || !this.inputs.length.valid() ) {
                  event.preventDefault();
                  return;
              }
              event.preventDefault();
              console.log(this.type)
              if(this.type) {
                  console.log('click add')
                  var button = $('[data-product-add-to-cart-button]');
                  button.prop('disabled', true);
                  button.attr("aria-busy", "true");
                  this.addCustomProduct();
                  event.preventDefault();
              }
          }.bind(this));
      }
  
      update(config, variant_id) {
          console.log('config', config);
          this.inputs.qty.val(1);
          this.variant_id = variant_id;
          this.type = null;
          this.config = config;
          this.minimal_price = config.price;
          this.minimal_compare_at_price = config.compare_at_price;
          if(config.data) {
              this.type = config.data.pricing_type;
              this.width_range = config.data.width_range;
              this.height_range = config.data.height_range;
              this.length_range = config.data.length_range;
  
              if (this.type == 'length') {
                  this.width = config.data.fixed_width;
                  this.ranges.length.html(this.length_range);
  
                  this.min_length = parseInt(this.length_range.split("-")[0]);
                  this.max_length = parseInt(this.length_range.split("-")[1]);
                  this.min_area = this.width * this.min_length; //minimal area in cm2
  
                  this.inputs.length.rules('add', {
                          required: true,
                          range: [this.min_length, this.max_length]
                      }
                  );
  
              } else {
                  this.ranges.width.html(this.width_range);
                  this.ranges.height.html(this.height_range);
  
                  this.min_width = parseInt(this.width_range.split("-")[0]);
                  this.min_height = parseInt(this.height_range.split("-")[0]);
                  this.max_width = parseInt(this.width_range.split("-")[1]);
                  this.max_height = parseInt(this.height_range.split("-")[1]);
  
                  this.min_area = this.min_width * this.min_height; //minimal area in cm2
  
                  this.inputs.width.rules('add', {
                          required: true,
                          range: [this.min_width, this.max_width]
                      },
  
                  );
                  this.inputs.height.rules('add', {
                          required: true,
                          range: [this.min_height, this.max_height]
                      }
                  );
              }
  
              this.updateUnitPrice();
          }
  
          this.recalculatePrice();
  
          this.updateWidthVisibility();
  
      }
  
      addCustomProduct() {
          $('#dp_height').val(this.getHeight());
          $('#dp_width').val(this.getWidth());
          $('#dp_length').val(this.getLength());
  
          jQuery.ajax({
              type: 'GET',
              url: '/apps/proxy',
              data: {id: this.variant_id, price: this.price/100},
              dataType: 'json',
              success: function(data) {
                  let new_prod_id = data['id'];
                  let new_variant_id = data['variants'][0]['id'];
  
                  if(new_variant_id) {
                      var option = new Option(new_prod_id, new_variant_id);
                      $(option).html(new_prod_id);
                      $('[name=id]').append(option);
                      $('[name=id]').val(new_variant_id);
  
                      var form = $(".product-form__buy-buttons form").first()[0];
                      form.requestSubmit();
                  }
              }
          });
      }
  
      updateWidthVisibility() {
          jQuery('.custom-input-section').hide();
          jQuery('.c-custom-sizes__wrapper').hide();
          jQuery('.c-custom-sizes').removeClass('c-custom-sizes__wrapper');
          this.inputs.width.prop( "disabled", true );
          this.inputs.height.prop( "disabled", true );
          this.inputs.length.prop( "disabled", true );
          this.inputs.width.val('');
          this.inputs.height.val('');
          this.inputs.length.val('');
  
          this.hidden_inputs.width.prop( "disabled", true );
          this.hidden_inputs.height.prop( "disabled", true );
          this.hidden_inputs.length.prop( "disabled", true );
          this.hidden_inputs.width.val('');
          this.hidden_inputs.height.val('');
          this.hidden_inputs.length.val('');
  
  
          if(jQuery('.c-custom-sizes__wrapper').length === 0 && jQuery('.product-form__variants .block-swatch:not(.is-disabled) [value=-]').length ) {
              jQuery(".product-form__option-selector.breite_auswählen, .c-custom-sizes ").wrapAll("<div class='c-custom-sizes__wrapper' style='display: none;'></div>");
          }
          if(jQuery('.c-custom-sizes__wrapper').length === 0 && this.type == 'length') {
              jQuery(".product-form__option-selector.breite_auswählen, .c-custom-sizes ").wrapAll("<div class='c-custom-sizes__wrapper' style='display: none;'></div>");
              const $label = jQuery(".product-form__option-selector.breite_auswählen .product-form__option-name");
              $label.text('1. ' +  $label.text());
          } else if (this.type == 'area') {
              jQuery('.c-custom-sizes').addClass('c-custom-sizes__wrapper');
          }
  
          if (this.type == 'length') {
              jQuery('.c-custom-sizes__wrapper').show();
              jQuery('.length-input-section').show();
              // if (jQuery(window).width() < 768) {
              //     jQuery('html, body').animate({
              //         scrollTop: jQuery('.custom-size--wrapper').offset().top
              //     }, 1000);
              // }
              this.inputs.width.prop( "disabled", true );
              this.inputs.height.prop( "disabled", true );
              this.inputs.length.prop( "disabled", false );
              this.inputs.length.val('')
  
              this.hidden_inputs.width.prop( "disabled", true );
              this.hidden_inputs.height.prop( "disabled", true );
              this.hidden_inputs.length.prop( "disabled", false );
              this.hidden_inputs.length.val('')
  
          } else if (this.type == 'area'){
              jQuery('.c-custom-sizes__wrapper').show();
              jQuery('.area-input-section').show();
              // if (jQuery(window).width() < 768) {
              //     jQuery('html, body').animate({
              //         scrollTop: jQuery('.custom-size--wrapper').offset().top
              //     }, 1000);
              // }
              this.inputs.width.prop( "disabled", false );
              this.inputs.height.prop( "disabled", false );
              this.inputs.length.prop( "disabled", true );
  
              this.hidden_inputs.width.prop( "disabled", false );
              this.hidden_inputs.height.prop( "disabled", false );
              this.hidden_inputs.length.prop( "disabled", true );
          }
  
          var dashOption = jQuery('[data-product-options-container] .form-options [value=-]');
  
          if(dashOption) {
              dashOption.parent().hide();
              let options_count = dashOption.parents('.option-values').find('input:enabled').length;
              if(options_count == 1 && (dashOption.parents('.option-values').find('input:enabled')).val() == '-'){
                  dashOption.parents('.form-options, .custom-size--wrapper').hide();
              } else {
                  dashOption.parents('.form-options, .custom-size--wrapper').show();
              }
          }
  
      }
  
      updateUnitPrice()
      {
          this.price_per_sqm = 0;
          if (this.type == 'area') {
              var area = 100 * 100; // area in cm2
                  if (this.min_area != 0) this.price_per_sqm = area * this.minimal_price / this.min_area;
          } else {
              var area = 100*100; // area in cm2
              if(this.min_area != 0) this.price_per_sqm = area * this.minimal_price / this.min_area;
          }
  
          if(this.price_per_sqm > 0) $('.price_per_sqm').html(this.formatMoney(this.price_per_sqm,'Quadratmeter: {{amount}} €'));
  
          if (["b2b", "b2binst"].includes(jQuery.cookie('customer_type')))
          {
            if(this.price_per_sqm > 0) $('.price_per_sqm').html(this.formatMoney(this.price_per_sqm / 1.19,'Quadratmeter: {{amount}} €'));
          } else {
            if(this.price_per_sqm > 0) $('.price_per_sqm').html(this.formatMoney(this.price_per_sqm,'Quadratmeter: {{amount}} €'));
          }
      }
  
      getWidth() {
          let value = parseInt(this.inputs.width.val());
          if (isNaN(value)) return 0;
          return value;
      }
  
      getHeight() {
          let value = parseInt(this.inputs.height.val());
          if (isNaN(value)) return 0;
          return value;
      }
  
      getLength() {
          let value = parseInt(this.inputs.length.val());
          if (isNaN(value)) return 0;
          return value;
      }
  
      setWidth(value) {
          this.inputs.height.val(value);
      }
  
      setHeight(value) {
          this.inputs.height.val(value);
      }
  
      setLenght(value) {
          this.inputs.length.val(value)
      }
  
      validate(el) {
  
      }
  
      checkInput(event) {
          let allowedKeyCode = [0,8,9,  //delete,tab
              37,38,39,40, //arrows
              46, //numpad delete
              48,49,50,51,52,53,54,55,56,57, //numbers
              96,97,98,99,100,101,102,103,104,105]; // numpad numbers
          let code = window.event ? event.keyCode : event.which;
  
          if (Array.prototype.indexOf.call(allowedKeyCode, code) < 0) {
              event.preventDefault();
              return;
          }
      }
  
      recalculatePrice() {
          switch (this.type) {
              case 'area':
  
                  this.values.width = this.getWidth();
                  this.values.height = this.getHeight();
  
                  if (this.values.width < this.min_width) this.values.width = this.min_width;
                  if (this.values.width > this.max_width) this.values.width = this.max_width;
                  if (this.values.height < this.min_height) this.values.height = this.min_height;
                  if (this.values.height > this.max_height) this.values.height = this.max_height;
  
                  this.area = this.values.width * this.values.height;
                  this.price = this.area * this.minimal_price / this.min_area;
                  this.compare_at_price = this.area * this.minimal_compare_at_price / this.min_area;
                  break;
              case 'length':
  
                  this.values.length = this.getLength();
  
                  if (this.values.length < this.min_length) this.values.length = this.min_length;
                  if (this.values.length > this.max_length) this.values.length = this.max_length;
  
                  this.min_area = this.min_length * this.width;
                  this.area = this.values.length * this.width;
                  this.price = this.area * this.minimal_price / this.min_area;
                  this.compare_at_price = this.area * this.minimal_compare_at_price / this.min_area;
                  break;
              default:
                  this.price = this.minimal_price;
                  this.compare_at_price = this.minimal_compare_at_price;
          }
          this.price = Math.round(this.price);
  
          let qty = this.inputs.qty.val();
  
              //$('[data-price] .money').html(Shopify.formatMoney(this.price,'{{amount_with_comma_separator}} €'));
  
              if (["b2b", "b2binst"].includes(jQuery.cookie('customer_type')))
              {
                  $('.price--large').html(this.formatMoney(this.price / 1.19,'{{amount_with_comma_separator}} €'));
                  if(this.compare_at_price > 0) {
                      $('.product-meta__price-row .price--compare').html(this.formatMoney(this.compare_at_price / 1.19,'{{amount_with_comma_separator}} €'));
                      $('.product-meta__price-row .price--large').addClass('price--highlight');
                  } else {
                      $('.product-meta__price-row .price--compare').html('');
                      $('.product-meta__price-row .price--large').removeClass('price--highlight');
                  }
              } else {
                  $('.price--large').html(this.formatMoney(this.price,'{{amount_with_comma_separator}} €'));
                  if(this.compare_at_price > 0) {
                      $('.product-meta__price-row .price--compare').html(this.formatMoney(this.compare_at_price,'{{amount_with_comma_separator}} €'));
                      $('.product-meta__price-row .price--large').addClass('price--highlight');
                  } else {
                      $('.product-meta__price-row .price--compare').html('');
                      $('.product-meta__price-row .price--large').removeClass('price--highlight');
                  }
              }
  
              // if(qty > 1) {
              //     $('.product--price-part').show();
              //     $('.product--price-part').html(qty+' x '+this.formatMoney(this.price,'{{amount_with_comma_separator}} €')+' = <span>'+this.formatMoney(qty*this.price,'{{amount_with_comma_separator}} €'+'</span>'));
              // } else {
              //     $('.product--price-part').hide();
              // }
      }
  
      formatMoney(cents, format = "") {
          if (typeof cents === "string") {
            cents = cents.replace(".", "");
          }
          const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
          function defaultTo(value2, defaultValue) {
            return value2 == null || value2 !== value2 ? defaultValue : value2;
          }
          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");
            if (isNaN(number) || number == null) {
              return 0;
            }
            number = (number / 100).toFixed(precision);
            let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
          }
          let value = "";
          switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
              value = formatWithDelimiters(cents, 2);
              break;
            case "amount_no_decimals":
              value = formatWithDelimiters(cents, 0);
              break;
            case "amount_with_space_separator":
              value = formatWithDelimiters(cents, 2, " ", ".");
              break;
            case "amount_with_comma_separator":
              value = formatWithDelimiters(cents, 2, ".", ",");
              break;
            case "amount_with_apostrophe_separator":
              value = formatWithDelimiters(cents, 2, "'", ".");
              break;
            case "amount_no_decimals_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              value = formatWithDelimiters(cents, 0, " ");
              break;
            case "amount_no_decimals_with_apostrophe_separator":
              value = formatWithDelimiters(cents, 0, "'");
              break;
          }
          if (formatString.indexOf("with_comma_separator") !== -1) {
            return formatString.replace(placeholderRegex, value);
          } else {
            return formatString.replace(placeholderRegex, value);
          }
        }
  };
  
  window.addEventListener("load", (event) => {
      let dp = new DynamicPricing();
  
      var id = jQuery('.product-form__buy-buttons [name=id]').val();
      let config = JSON.parse(document.querySelector('[data-dynamic-pricing]')?.innerHTML || null);
      if(selected_variant && config) {
      var selected_variant = config[id];
  
          dp.update(selected_variant, id);
          console.log('1');
      }
  
      document.addEventListener('variant:changed', function(event) {
          let variant = event.detail.variant; // Gives you access to the whole variant details
          let form = event.target;
          var selected_variant = config[variant.id];
          if(selected_variant) {
              dp.update(selected_variant, variant.id);
              console.log('2');
        }
        //update title of the product for selected variant
          const title = variant.name;
          $('.product-meta .product-meta__title').html(title);
      });
  
      const allDrawers = document.querySelectorAll('quick-buy-drawer');
  
      // Function to execute when the drawer opens
      const onDrawerOpen = (drawer) => {
          dp = new DynamicPricing();
          id = jQuery('.product-form__buy-buttons [name=id]').val();
          console.log(id);
          config = JSON.parse(document.querySelector('[data-dynamic-pricing]').innerHTML);
          selected_variant = config[id];
          if(selected_variant) {
      
              dp.update(selected_variant, id);
              console.log('1');
          }
  
          document.addEventListener('variant:changed', function(event) {
              let variant = event.detail.variant; // Gives you access to the whole variant details
              console.log(variant)
              let form = event.target;
              let selected_variant = config[variant.id];
              if(selected_variant) {
                  dp.update(selected_variant, variant.id);
                  console.log('2');
          }
          //update title of the product for selected variant
              const title = variant.name;
              $('.product-meta .product-meta__title').html(title);
          });
          console.log('Drawer is now open:', drawer);
      }
  
      // MutationObserver callback function
      const observerCallback = function(mutationsList, observer) {
          for (const mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                  const drawer = mutation.target;
                  if (drawer.hasAttribute('open')) {
                      onDrawerOpen(drawer);
                  }
              }
          }
      };
  
      // Create a new observer instance with the callback function
      const observer = new MutationObserver(observerCallback);
  
      // Options for the observer (we're only interested in attributes)
      const observerOptions = {
          attributes: true, // Watch for attribute changes
          attributeFilter: ['open'] // Specifically for the 'open' attribute
      };
  
      // Start observing each 'quick-buy-drawer' for mutations with the specified options
      allDrawers.forEach(drawer => {
          observer.observe(drawer, observerOptions);
      });
  
  });
  
  
  
  */
  